import { render, staticRenderFns } from "./NoDataCertificateList.vue?vue&type=template&id=bd00e248&scoped=true&"
import script from "./NoDataCertificateList.vue?vue&type=script&lang=js&"
export * from "./NoDataCertificateList.vue?vue&type=script&lang=js&"
import style0 from "./NoDataCertificateList.vue?vue&type=style&index=0&id=bd00e248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd00e248",
  null
  
)

export default component.exports